import React, { useMemo } from "react";
import Header from "../component/Header";
import ExploreResultLocations from "../component/ExploreResultLocations";
import Footer from "../component/Footer";
import ConnectAgentCTA from "../component/ConnectAgentCTA";
import CommonBanner from "../component/CommonBanner";
import { Col, Container } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useBlogList } from "../hooks/useBlogList";
import { usePageContent } from "../hooks/usePageContent";
import { Helmet } from "react-helmet-async";

function Blogs() {
  const { blogs, loading, error } = useBlogList();
  const { content } = usePageContent("blogs");

  // Parse blogs_section data
  const blogsSectionData = useMemo(() => {
    if (!content?.blogs_section) return null;
    try {
      return JSON.parse(content.blogs_section);
    } catch (error) {
      console.error("Error parsing blogs_section:", error);
      return null;
    }
  }, [content]);

  // Default values
  const bannerTitle = content?.page_name || "Blogs";
  const bannerImage = content?.main_banner_image;

  return (
    <>
      <Helmet>
        <title>{`${bannerTitle} | Jambobay`}</title>
        <meta
          name="description"
          content="Read the latest real estate news, guides, and insights from Jambobay."
        />
        <meta
          name="keywords"
          content="Blogs, Jambobay, Real Estate News, Guides, Insights"
        />
      </Helmet>
      <div className="main blog-page">
        <Header />
        <CommonBanner 
          title={bannerTitle}
          bannerImage={bannerImage}
        />
        <div className="blog-list common-padding">
          <Container>
            <div className="common-header">
              <h2 className="mb-0" dangerouslySetInnerHTML={{ 
                __html: blogsSectionData?.section_1?.title || "Latest <span>Blogs</span>"
              }} />
            </div>
            <Row className="row-gap-4">
              {loading && <p>Loading blogs...</p>}
              {error && <p className="text-danger">{error}</p>}
              {!loading && !error && blogs.length === 0 && <p>No blogs found</p>}
              {!loading && blogs.map((blog) => (
                <Col lg={4} md={6} sm={12} key={blog.id}>
                  <Link to={`/blogs-details/${blog.slug || blog.id}`} className="blog-item">
                    <div className="blog-image">
                      <img 
                        src={blog.image}
                        alt={blog.title} 
                      />
                    </div>
                    <div className="blog-content">
                      <p>{blog.category_name}</p>
                      <h3>{blog.title}</h3>
                    </div>
                  </Link>
                </Col>
              ))}
            </Row>
          </Container>
        </div>
        <ConnectAgentCTA section={blogsSectionData?.section_2} />
        <ExploreResultLocations section={blogsSectionData?.section_5} />
        <Footer />
      </div>
    </>
  );
}

export default Blogs;
